import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Link, Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import config from "../function/config";
import axios from "axios";
import HomeNav from "./Navbars/HomeNav";
import Footer from "./Footer";
import Logo from "./video/Mariniz Logo Gold.png";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { toast } from "react-toastify";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import NewHomeNav from "./Navbars/NewHomeNav";
import NewFooter from "./NewFooter";


export default function SingleRegShipForSale() {
    const [obj, setObj] = useState({});



    const navigate = useNavigate();
  
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenS, setIsOpenS] = useState(true);
  
    const { id } = useParams();


   
  
    const [isScrolled, setIsScrolled] = useState(false);
    
     useLayoutEffect(() => {
  window.scrollTo(0, 0);
}, [id]);

    const [thumbnailImage, setThumbnailImage] = useState("");
const [mainImages, setMainImages] = useState([]); 
  
   useEffect(() => {
  async function fetchData() {
    try {
      // Fetch ship basic info
      const shipRes = await axios.get(
        `${config.base_url}/api/HappyMarineShipping/singleshipReg/${id}`
      );

      if (shipRes.data.status === 200 && shipRes.data.data) {
        setObj(shipRes.data.data);
      } else {
        // ❌ No ship found → redirect
        navigate("/ship-for-sale", { replace: true });
        return;
      }

      // Fetch images from ShipImageReg
      const imgRes = await axios.get(
        `${config.base_url}/api/HappyMarineShipping/singleShipImageReg/${id}`
      );
      if (imgRes.data.status === 200 && imgRes.data.data.length > 0) {
        const thumbnailImageData = imgRes.data.data.find(
          (img) => img.thumbnail_image !== null
        );
        const mainImagesData = imgRes.data.data
          .filter((img) => img.image !== null)
          .map((img) => img.image);

        setThumbnailImage(thumbnailImageData?.thumbnail_image || "");
        setMainImages(mainImagesData);
      }
    } catch (err) {
      console.log("Error fetching data:", err);
      // ❌ If request itself fails, also redirect
      navigate("/ship-for-sale", { replace: true });
    }
  }

  fetchData();
}, [id, navigate]);

    
  
    const { pathname } = useLocation();
  
    useEffect(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, [pathname]);

    const location = useLocation();
    
    // Extract 'page' from the URL
    const searchParams = new URLSearchParams(location.search);
    const prevPage = location.state?.from || "/ship-for-sale";
const prevPageNumber = location.state?.page || 1; // Default to page 1 if not found

const handleBack = () => {
  navigate(`${prevPage}?page=${prevPageNumber}`); // Restore previous page with correct pagination
};

const [isOpenModal, setIsOpenModal] = useState(false);        // for dropdown
const [showModal, setShowModal] = useState(false);  // for enquiry modal
const [Name,setName] = useState('')
const [Email,setEmail] = useState('')
const [Mobile,setMobile] = useState('')
const [Subject,setSubject] = useState('')
const [loading,setLoading] =useState(false)
const [count,setCount] = useState(1)

  const EnquirySubmit = async(e)=>{
    e.preventDefault();
    setLoading(true)
    const formData = new FormData();
      formData.append("name", Name);
      formData.append("email", Email);
      formData.append("mobile", Mobile);
      formData.append("subject", Subject);
          
    try {
                  
                    const response = await axios.post(`${config.base_url}/api/HappyMarineShipping/add_enquiry`,formData,{
                      headers:{
                        'Content-Type':'multipart/form-data',
                      }
                    });
                    if(response.data.status===200){
                     
                      console.log(response)
                      setLoading(false)
                      setShowModal(false)
                      toast.success("Sent Successfully!",{
                        autoClose:1500,
                        position:'top-right',
                        
                      });
                      setCount(id)
                     
                     
                      
                    }
                    else{
                        setLoading(false)
                      console.log("error1")
                      toast.error("Fill the required Fields",{
                        autoClose:1500,
                        position: "top-right",
                      })
                    }
                    
                  } catch (err) {
                    setLoading(false)
                    console.log("error2",err)
                    toast.error("Error",{
                      autoClose:2000,
                      position: "top-right",
                    })
                  }

  }

  
  const [allShips, setallShips] = useState([]);
    const [allShipsReg, setallShipsReg] = useState([]);
  
   
    // Fetch Admin Ships
  useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(`${config.base_url}/api/HappyMarineShipping/viewShip`, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (res1.data.status === 200) {
          const sortedData = res1.data.data.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
          setallShips(sortedData); 
          setCount(id);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);
  
  
  // Fetch Customer Registered Ships
  useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(`${config.base_url}/api/HappyMarineShipping/viewShipForSale`, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (res1.data.status === 200) {
          // Sort using created_at (not date_added)
          const sortedData = res1.data.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)); 
          setallShipsReg(sortedData);
          setCount(id);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);
  
  
    
  
    useEffect(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, [pathname]);
  
  const [allImages,setallImages] = useState([])
   
    
    useEffect(() => {
      async function fetchdata() {
        try {
          const res3 = await axios.get(
            `${config.base_url}/api/HappyMarineShipping/ship_images`,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              }
            }
          );
          if (res3.data.status === 200) {
            console.log("Images :",res3);
            setallImages(res3.data.data);
          } else {
            console.log("error");
          }
        } catch (error) {
          console.log(error);
        }
      }
      fetchdata();
    }, [config.base_url,count]);

    const [allImagesReg,setAllImagesReg] = useState([])
        
          useEffect(() => {
            async function fetchdata() {
              try {
                const res3 = await axios.get(
                  `${config.base_url}/api/HappyMarineShipping/ship_images_Reg`,
                  {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    }
                  }
                );
                if (res3.data.status === 200) {
                  console.log("Images :",res3);
                  setAllImagesReg(res3.data.data);
                } else {
                  console.log("error");
                }
              } catch (error) {
                console.log(error);
              }
            }
            fetchdata();
          }, [config.base_url,count]);
  
    // Add an identifier to distinguish Admin Ships and Customer Ships
  const filteredAllShipsReg = allShipsReg
  .filter((ship) => ship.is_allow)
  .map((ship) => ({ ...ship, isFromReg: true })); // Mark as from RegisterShipForSale
  
  const allShipsWithFlag = allShips.map((ship) => ({ ...ship, isFromReg: false })); // Mark as Admin Ship
  
  // Merge and sort ships by created_at (latest first)
  const sortedData = [...allShipsWithFlag, ...filteredAllShipsReg].sort(
  (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );

  function shuffleArray(array) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

const similarShips = shuffleArray(
  sortedData.filter(
    (ship) => ship.vessel_type === obj.vessel_type && ship.id !== obj.id
  )
);


  const [selectedImage, setSelectedImage] = useState(null);
  
  // Add this above your return block or inside the component
  const handleCloseModal = () => setSelectedImage(null);
  
const [showShareOptions, setShowShareOptions] = useState(false);

const shareRef = useRef(null);

useEffect(() => {
  function handleClickOutside(event) {
    if (shareRef.current && !shareRef.current.contains(event.target)) {
      setShowShareOptions(false);
    }
  }

  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, []);


const shipRef = useRef();


const handleDownload = () => {
  const element = shipRef.current;
  if (!element) {
    console.error("No element found to export.");
    return;
  }

  // Hide visual-only elements
  const dropdown = document.querySelector(".animate-fade-in");
  const shareButton = document.querySelector(".fa-share-nodes")?.closest("button");
  const enquiryButton = document.querySelector("button.text-black");

  if (dropdown) dropdown.style.display = "none";
  if (shareButton) shareButton.style.display = "none";
  if (enquiryButton) enquiryButton.style.display = "none";

  // Show PDF-only layout
  element.style.display = "block";

  // Wait for all images inside the element to load
  const images = element.querySelectorAll("img");
  const imagePromises = Array.from(images).map((img) => {
    return new Promise((resolve) => {
      if (img.complete) {
        resolve();
      } else {
        img.onload = img.onerror = resolve;
      }
    });
  });

  Promise.all(imagePromises).then(() => {
    html2canvas(element, {
      scale: 2,
      useCORS: true,
      allowTaint: false, // safer option
      scrollY: -window.scrollY,
      backgroundColor: "#123d5f",
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let position = 0;
      let heightLeft = imgHeight;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position -= pageHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      // Restore
      element.style.display = "none";
      if (dropdown) dropdown.style.display = "";
      if (shareButton) shareButton.style.display = "";
      if (enquiryButton) enquiryButton.style.display = "";

      pdf.save("ship-details.pdf");
    });
  });
};


const [username, setusername] = useState("");
    const [password, setPassword] = useState("");
   
    const [usernameError, setUsernameError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [Signin, setSignin] = useState("Signin");
    // Validate username
    const validateUsername = (value) => {
      if (!value) {
        setUsernameError("Username is required");
      } else {
        setUsernameError("");
      }
    };
  
    // Validate password
    const validatePassword = (value) => {
      if (!value) {
        setPasswordError("Password is required");
      } else if (value.length < 4) {
        setPasswordError("Password must be at least 4 characters");
      } else {
        setPasswordError("");
      }
    };
  
    const handleSubmit = async () => {
      setLoading(true);
      const data = {
        email: username,
        password: password,
      };
      try {
        const response = await axios.post(
          `${config.base_url}/api/HappyMarineShipping/login`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response.data.status === 200) {
          setLoading(false);
          console.log(response);
          localStorage.setItem("token", response.data.token);
          if (response.data.is_admin === true) {
            localStorage.setItem("admin", "t");
            console.log("Admin token:", response.data.token); // ✅ log admin token
            window.location.href = "/adminHome";
          } else {
            window.location.href = '/userHome'
          }
        } else {
          console.log(response);
          toast.error(response.data.message, {
            autoClose: 3000,
            position: "top-right",
          });
          setLoading(false);
        }
      } catch (err) {
        console.log("error2", err);
        toast.error("Error", {
          autoClose: 3000,
          position: "top-right",
        });
        setLoading(false);
      }
    };
  
    const [showPassword, setShowPassword] = useState(false);
     const [isLoginOpen, setIsLoginOpen] = useState(false);

   const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [address, setAddress] = useState("");

  const [confirmPassword, setConfirmPassword] = useState("");
  const [image,setImage] = useState('')


  // Error states
  const [emailError, setEmailError] = useState(false);
  const [mobileError, setMobileError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);


    
  
  // Email validation (simple regex)
  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmailError(!emailRegex.test(value));
  };
  
  const validateMobile = (value) => {
    const mobileRegex = /^\+\d{7,15}$/;
    setMobileError(!mobileRegex.test(value));
  };
  
  
  // Confirm Password validation (must match Password)
  const validateConfirmPassword = (value) => {
    setConfirmPasswordError(value !== password);
  };
  
  
    const handleSubmitSignup = async () => {
    // Run all validations first
    validateUsername(username);
    validateEmail(Email);
    validateMobile(Mobile);
    validatePassword(password);
    validateConfirmPassword(confirmPassword);
  
    // Check for any errors or empty required fields
    if (
      usernameError ||
      emailError ||
      mobileError ||
      passwordError ||
      confirmPasswordError ||
      !firstName ||
      !lastName ||
      !username ||
      !Email ||
      !Mobile ||
      !password ||
      !confirmPassword
    ) {
      toast.error("Please fix form validation errors before submitting.", {
        autoClose: 1500,
        position: "top-right",
      });
      return;
    }
  
    setLoading(true);
  
    const formData = new FormData();
    formData.append("email", Email);
    formData.append("username", username);
    formData.append("first_name", firstName);
    formData.append("last_name", lastName);
    formData.append("phone", Mobile);
    formData.append("address", address);
    formData.append("password", password);
    if (image) {
      formData.append("image", image);
    }
  
    try {
      const response = await axios.post(
        `${config.base_url}/api/HappyMarineShipping/signup`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      if (response.data.status === 200) {
    toast.success("Registered Successfully", {
      autoClose: 1500,
      position: "top-right",
      onClose: () => navigate("/login"),
    });
  } else if (
    response.data.status === 400 &&
    response.data.message === "Email already exists"
  ) {
    toast.error("Email already exists", {
      autoClose: 1500,
      position: "top-right",
    });
  } else if (
    response.data.status === 400 &&
    response.data.message === "Username already exists"
  ) {
    toast.error("Username already exists", {
      autoClose: 1500,
      position: "top-right",
    });
  } else {
    toast.error("Something went wrong. Try again.", {
      autoClose: 1500,
      position: "top-right",
    });
  }
  
    } catch (err) {
      console.error(err);
      toast.error("Network error. Please try again.", {
        autoClose: 1500,
        position: "top-right",
      });
    } finally {
      setLoading(false);
    }
  };
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    


    const [resetEmail, setResetEmail] = useState("");
const [resetLoading, setResetLoading] = useState(false);

const handleForgotPassword = async () => {
  if (!resetEmail) {
    toast.error("Please enter your email");
    return;
  }
  setResetLoading(true);
  try {
    const res = await axios.post(`${config.base_url}/api/HappyMarineShipping/forgot-password/`, {
      email: resetEmail,
    });
    if (res.data.status === 200) {
      toast.success("Reset link sent to your email");
      setSignin("Signin");
    } else {
      toast.error(res.data.message);
    }
  } catch (err) {
    toast.error("Something went wrong");
  } finally {
    setResetLoading(false);
  }
};


 if (!id) {
    return <Navigate to="/ship-for-sale" replace />;
  }



  return (
   <div className="bg-[#9ccee2]">
         <NewHomeNav />
         <div className="px-10 lg:hidden mt-5">
         <button className="text-white" onClick={handleBack}>
         <i class='bx bx-chevrons-left bx-flashing bx-flip-vertical' ></i> Back
         </button>
           </div>
         
   
         <div className="px-10 xm:px-2 lg:block hidden mt-5">
         <button className="text-white" onClick={handleBack}>
         <i class='bx bx-chevrons-left bx-flashing bx-flip-vertical' ></i> Back
         </button>
           </div>
   
        <div className="flex gap-5  2xl:block  xm:p-3  mb-10 px-10">
               
        
                {/* 2nd div description */}
                <div  className="w-[70%] 2xl:w-[100%] h-full 2xl:mt-5 border rounded  border-gray-400 bg-white flex flex-col ">
                   <div ref={shipRef} className="hidden-for-pdf w-full bg-[#2e5775] p-4 text-white">
  {/* 1. Ship Image */}
  <div className="w-full mb-4">
    {mainImages.length > 0 ? (
      <img src={mainImages[0]} className="w-[700px] xm:h-auto xm:w-auto m-auto h-[450px]" alt="Ship Image" />
    ) : (
      <img src="fallback.jpg" className="w-[700px] xm:h-auto xm:w-auto m-auto h-[450px]" alt="No Image" />
    )}
  </div>

  {/* 2. Short Description and Specs */}
  <div className="mb-4">
    {obj.short_description && (
      <div className="mb-2">
        <strong className="text-[#2e5775]">Short Description:</strong> {obj.short_description}
      </div>
    )}
    {obj.year_built && (
      <div>
        <strong>Year Built:</strong> <span className="text-[#2e5775]">{obj.year_built}</span>
      </div>
    )}
    {obj.LOA && (
      <div>
        <strong>LOA:</strong> <span className="text-[#2e5775]">{obj.LOA}</span>
      </div>
    )}
    {obj.Flag && (
      <div>
        <strong>Flag:</strong> <span className="text-[#d1a460]">{obj.flag}</span>
      </div>
    )}
    {obj.Class && (
      <div>
        <strong>Class:</strong> <span className="text-[#d1a460]">{obj.Class}</span>
      </div>
    )}
    {obj.GRT_NRT && (
      <div>
        <strong>GRT/NRT:</strong> <span className="text-[#d1a460]">{obj.GRT_NRT}</span>
      </div>
    )}
    {obj.Teu && (
      <div>
        <strong>Teu:</strong> <span className="text-[#d1a460]">{obj.Teu}</span>
      </div>
    )}
    {obj.DWT && (
      <div>
        <strong>DWT:</strong> <span className="text-[#d1a460]">{obj.DWT}</span>
      </div>
    )}
    {obj.Price && (
      <div>
        <strong>Price:</strong> <span className="text-[#d1a460]">{obj.Price}</span>
      </div>
    )}
    {obj.main_engine && (
      <div>
        <strong>Main Engine:</strong> <span className="text-[#d1a460]">{obj.main_engine}</span>
      </div>
    )}
  </div>

  {/* 3. More Informations */}
  <div>
    <h2 className="text-xl font-bold text-[#d1a460] mb-2">More Informations</h2>
    {obj.brief_description ? (
      obj.brief_description.split("\n").map((line, idx) => (
        <p key={idx} className="mb-1 whitespace-pre-wrap break-words">{line}</p>
      ))
    ) : (
      <p className="text-red-400">No description available</p>
    )}
  </div>
</div>
                  
                  <div className=" rounded-t ">
                    <div className="text-[#2e5775]">
                      <div className="px-3 py-3">
                        <div
                          className="flex justify-between items-center xm:text-lg xm:px-2 rounded bg-[#2e5775] py-3 text-white font-bold text-xl px-4 cursor-pointer"
                          
                        >
                          
                          <h1>Short Descriptions</h1>
                          <h1 className=""> Ref : {obj.ship_code} - {id}</h1>
                         
                            
                        </div>
                      </div>
        
                      
                        <div   className="flex justify-between md:flex-wrap-reverse px-3 w-[100%]"> 
        
                          <div className="px-3 py-3 w-[90%]">
                            {/* Short Description */}
                            {obj.short_description && (
                              <div className="flex gap-3 border-b border-gray-300 py-1">
                               <span className="text-[#2e5775]   font-bold px-1  ">
                                        {obj.short_description}
                                      </span>
                              </div>
                            )}
          
                            {/* Flag and Capacity */}
                           
                            {/* LOA and Built Year */}
                            {(obj.Flag || obj.year_built) && (
                              <div className="  mt-3">
                                {obj.year_built && (
                                  <div className="w-full">
                                    <span className="font-semibold  ">
                                      Year Built:
                                    </span>
                                    <span className="text-[#2e5775] ml-[27px]">
                                      {obj.year_built}
                                    </span>
                                  </div>
                                )}
                                 {(obj.LOA || obj.capacity) && (
                              <div className=" ">
                                {obj.LOA && (
                                  <div className="w-full">
                                    <span className="font-semibold  ">
                                    LOA:
                                    </span>
                                    <span className="text-[#2e5775] ml-[72px]">
                                      {obj.LOA}
                                    </span>
                                  </div>
                                )}
                              </div>
                            )}
          
                                 {obj.Flag && (
                                  <div className="w-full">
                                    <span className="font-semibold  ">
                                      Flag:
                                    </span>
                                    <span className="text-[#2e5775] ml-[70px]">{obj.flag}</span>
                                  </div>
                                )}
                              </div>
                            )}
          
                            {/* Class and GRT/NRT */}
                            
                              <div className=" ">
                               
                              {obj.Class &&(
                                  <div className="w-full">
                                  <span className="font-semibold ">
                                  Class:
                                  </span>
                                  <span className="text-[#2e5775]  ml-[60px]">
                                  {
                                      obj.Class
                                  }
                                  </span>
                              </div>
                              )
                                  }
                               
                                
                                  {obj.GRT_NRT &&(
                                      <div className="w-full">
                                      <span className="font-semibold ">
                                        GRT/NRT:
                                      </span>
                                      <span className="text-[#2e5775] ml-[34px]">
                                        {
                                          obj.GRT_NRT
                                        }
                                      </span>
                                    </div>
                                  )
                                      }
                               
                              </div>
                            
          
                            {/* Main Engine and DWT */}
                            
                              <div className=" ">
                                <div className=" ">
                                
                                  {obj.Teu && (
                                      <div className="w-full">
                                    <span className="font-semibold ">
                                      Teu:
                                    </span>
                                    <span className="text-[#2e5775] ml-[77px]">
                                      {
                                        obj.Teu
                                      }
                                    </span>
                                  </div>)}
                              </div>
          
                                
                                  {obj.DWT &&(<div className="w-full">
                                    <span className="font-semibold ">
                                      DWT:
                                    </span>
                                    <span className="text-[#2e5775] ml-[70px]">
                                      {
                                        obj.DWT
                                      }
                                    </span>
                                  </div>)}
          
                                   <div className=" ">
                                
                                  {obj.Price && (
                                      <div className="w-full">
                                    <span className="font-semibold ">
                                      Price:
                                    </span>
                                    <span className="text-[#2e5775] ml-[68px]">
                                      {
                                        obj.Price
                                      }
                                    </span>
                                  </div>)}
                                
                              </div>
          
                                   {obj.main_engine && (
                                      <div className="w-full">
                                    <span className="font-semibold ">
                                      Main Engine:
                                    </span>
                                    <span className="text-[#2e5775] ml-2">
                                      {
                                        obj.main_engine
                                      }
                                    </span>
                                  </div>)}
                                
                              </div>
          
                              
                             
          
                              
          
                            {/* <div className="w-full mt-5">
                              <span
                                onClick={() => navigate(`/shipLoc/${obj.id}`)}
                                className=" text-blue-400 cursor-pointer hover:underline "
                              >
                                Track Location
                              </span>
                            </div> */}
                          </div>
        
                           <div className="w-[500px]  md:m-auto xm:w-full bg-[#2e5775] border p-2 border-gray-400">
  <div className="w-full h-full relative cursor-pointer">
    {mainImages.length > 0 ? (
      <>
        <img
          src={mainImages[0]}
          className="w-full xm:w-full h-full"
          alt="Ship Image"
          onClick={() => setSelectedImage(mainImages[0])}
        />
        {/* Hover Overlay */}
        <div
          onClick={() => setSelectedImage(mainImages[0])}
          className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300"
        >
          <span className="text-white text-sm font-semibold underline">
            Click here to view image
          </span>
        </div>

        {/* Enlarge Icon */}
        <div
          onClick={() => setSelectedImage(mainImages[0])}
          className="absolute bottom-2 right-2 bg-black bg-opacity-60 px-3 py-2 rounded-full hover:bg-opacity-90 transition"
          title="Click to enlarge"
        >
          <i class="fa-solid fa-up-right-and-down-left-from-center  text-white"></i>
        </div>
      </>
    ) : !thumbnailImage ? (
      <img
        src="fallback.jpg"
        className="w-full h-full"
        alt="No Image Available"
      />
    ) : null}
  </div>
</div>
                        </div>
                      
                       
                    </div>
                  </div>
                    {selectedImage && (
                      <div
                        className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
                        onClick={handleCloseModal}
                      >
                        <div
                          className="w-[1000px] h-[600px] xm:w-[500px] xm:h-[300px] overflow-auto"
                          onClick={(e) => e.stopPropagation()}
                        >
                          
                          <Swiper
                            modules={[Navigation, Pagination]}
                            navigation
                            pagination={{ clickable: true }}
                            loop={true}
                            initialSlide={mainImages.findIndex((img) => img === selectedImage)}
                            className="w-full h-full"
                          >
                            
                            {mainImages.map((image, index) => (
                              <SwiperSlide key={index}>
                                <div
                              onClick={handleCloseModal}
                              className="absolute top-2 right-2 cursor-pointer bg-opacity-60 px-4 py-2 rounded-full hover:bg-opacity-90 transition"
                            >
                              <h1 className="text-red-600 font-bold text-2xl ">X</h1>
                            </div>
                                <img
                                  src={image}
                                  onClick={handleCloseModal}
                                  alt={`Enlarged ${index}`}
                                  className="rounded-lg w-full h-full m-auto"
                                />
                              </SwiperSlide>
                            ))}
                          </Swiper>
                        </div>
                      </div>
                    )}
                  <div className=" px-3 mt-4 py-3">
                   <div className="border rounded border-gray-400">
          {/* Dropdown Header */}
          <div
            className="flex justify-between rounded items-center bg-[#2e5775] py-3 text-white font-bold text-xl px-4 cursor-pointer"
            
          >
            <h1>More Informations</h1>
            <div className="relative flex gap-4" ref={shareRef}>

               
  <button
    onClick={() => setShowShareOptions(!showShareOptions)}
    className="flex items-center gap-2 bg-white text-[#2e5775] border border-[#2e5775] rounded-full px-4 py-1.5 text-sm font-semibold hover:bg-[#8f7b5d] hover:text-white transition-all duration-300 shadow-sm"
  >
    <i className="fa-solid fa-share-nodes"></i> Share
  </button>


  

  {showShareOptions && (
  <div className="absolute right-0 mt-2 w-60 bg-white border border-gray-300 rounded-xl shadow-xl z-50 animate-fade-in">
    
    {/* Regular WhatsApp */}
    <button
      onClick={() => {
        const url = window.location.href;
        const message = `Check out this ship listing: ${url}`;
        window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank');
        setShowShareOptions(false);
      }}
      className="w-full flex items-center gap-2 px-4 py-2 text-green-600 hover:bg-green-50 transition-all"
    >
      <i className="fa-brands fa-whatsapp text-lg"></i> WhatsApp
    </button>

     <button
  onClick={() => {
    handleDownload();
    setShowShareOptions(false);
  }}
  className="w-full flex items-center gap-2 px-4 py-2 text-red-600 hover:bg-red-50 transition-all"
>
  <i className="fa-solid fa-file-pdf text-lg"></i> Download as PDF
</button>


    {/* WhatsApp Beta */}
    {/* <button
      onClick={() => {
        const url = window.location.href;
        const message = `Check out this ship listing: ${url}`;
        // WhatsApp Beta URL scheme (typically used with beta installs)
        window.open(`https://web.whatsapp.com/send?text=${encodeURIComponent(message)}`, '_blank');
        setShowShareOptions(false);
      }}
      className="w-full flex items-center gap-2 px-4 py-2 text-green-800 hover:bg-green-100 transition-all"
    >
      <i className="fa-brands fa-whatsapp text-lg"></i> WhatsApp Beta
    </button> */}

    {/* Email */}
    <button
      onClick={() => {
        const subject = 'Ship Listing';
        const body = `Check out this ship: ${window.location.href}`;
        window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        setShowShareOptions(false);
      }}
      className="w-full flex items-center gap-2 px-4 py-2 text-blue-600 hover:bg-blue-50 transition-all"
    >
      <i className="fa-solid fa-envelope text-lg"></i> Email
    </button>
  </div>
)}

</div>
            
          </div>

          {/* Dropdown Content */}
          
            <div className="relative p-3 text-base text-[#2e5775]">
              <div className="pr-32">
                {obj.brief_description ? (
                  obj.brief_description.split("\n").map((detail, index) => {
                    // Simple regex to detect URLs
                    const urlRegex = /(https?:\/\/[^\s]+)/g;
                    const parts = detail.split(urlRegex);
        
                    return (
                      <p key={index} className="mb-2 break-words whitespace-pre-wrap">
          {parts.map((part, i) =>
            urlRegex.test(part) ? (
              <a
                key={i}
                href={part}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline hover:text-blue-800 break-words"
              >
                {part}
              </a>
            ) : (
              <span key={i}>{part}</span>
            )
          )}
        </p>
        
                    );
                  })
                ) : (
                  <p className="text-red-500">No description available</p>
                )}
              </div>
        
              {/* Enquiry Now Button */}
              
                                    <button
                                onClick={() => setIsLoginOpen(true)}
                                className="absolute right-2 top-5  bg-gray-50 text-sm duration-300 text-[#2e5775] border border-[#a1ccec] hover:bg-[#2e5775] hover:text-white rounded-md px-3 py-1  shadow-lg hover:shadow-xl transition"
                              >
                                Owner Informations
                              </button>
                              {isLoginOpen && (
                              <div className="fixed inset-0  bg-black bg-opacity-50 flex justify-center items-center z-50">
                                    <div className="bg-gray-50 p-5  rounded-lg w-[40%] xm:w-[95%] relative">
                                      {/* Close button */}
                                      <button
                                        className="absolute right-3 top-3 text-gray-500 hover:text-red-500"
                                         onClick={() => setIsLoginOpen(false)}
                                      >
                                        ✕
                                      </button>
                              
                                      {Signin === "Signin" && (
                                        <>
                                           <div>
                                            <img src={Logo} className="w-[276px]  m-auto -mt-4 " alt="" />
                                            <h1 className="text-center text-[24px] ">Login</h1>
                                            </div>
                                          <form
                                            className="flex flex-col mt-3 gap-7"
                                            onKeyDown={(e) => {
                                              if (e.key === "Enter") {
                                                e.preventDefault();
                                                handleSubmit();
                                              }
                                            }}
                                          >
                                            {/* Username Field */}
                                            <input
                                              type="text"
                                              placeholder="Email or Username"
                                              value={username}
                                              onChange={(e) => {
                                                setusername(e.target.value);
                                                validateUsername(e.target.value);
                                              }}
                                              onBlur={() => validateUsername(username)}
                                              className={`w-full px-3 py-2 border ${
                                                usernameError ? "border-red-500" : "border-gray-300"
                                              } rounded-lg`}
                                            />
                              
                                            {/* Password Field */}
                                            <div className="relative">
                                              <input
                                                type={showPassword ? "text" : "password"}
                                                placeholder="Password"
                                                value={password}
                                                onChange={(e) => {
                                                  setPassword(e.target.value);
                                                  validatePassword(e.target.value);
                                                }}
                                                onBlur={() => validatePassword(password)}
                                                className={`w-full px-3 py-2 border ${
                                                  passwordError ? "border-red-500" : "border-gray-300"
                                                } rounded-lg`}
                                              />
                                              <div
                                                className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                                                onClick={() => setShowPassword(!showPassword)}
                                              >
                                                {showPassword ? (
                                                  <i className="fa-solid fa-eye-slash"></i>
                                                ) : (
                                                  <i className="fa-solid fa-eye"></i>
                                                )}
                                              </div>
                                            </div>
                              
                                            {/* Remember Me & Forgot Password */}
                                            <div className="flex justify-between items-center text-sm">
                                              <p>
                                                Not a Member?{" "}
                                                <Link
                                                  onClick={() => setSignin("Signup")}
                                                  className="text-[#2e5775] font-semibold"
                                                >
                                                  Signup
                                                </Link>
                                              </p>
                                              <button
                                                type="button"
                                                onClick={() => setSignin("resetpswd")}
                                                className="text-blue-500 hover:underline"
                                              >
                                                Forgot Password?
                                              </button>
                                            </div>
                              
                                            {/* Login Button */}
                                            <button
                                              type="submit"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                handleSubmit();
                                              }}
                                              className="w-full bg-[#253356] text-white py-2 rounded-lg hover:bg-[#1b2a4f] disabled:cursor-not-allowed"
                                              disabled={
                                                usernameError || passwordError || !username || !password
                                              }
                                            >
                                              {loading ? (
                                                <span className="block w-[16px] h-[16px] border-2 border-b-0 border-white rounded-full m-auto animate-spin"></span>
                                              ) : (
                                                "Login"
                                              )}
                                            </button>
                                          </form>
                                        </>
                                      )}
                              
                                      {/* Reset Password View */}
                                      {Signin === "resetpswd" && (
                                        <>
                                          <div className="flex justify-between items-center">
                                            <h1 className="text-xl">Recover Password</h1>
                                            <button onClick={() => setSignin("Signin")}>
                                              <i className="bx bx-arrow-back text-3xl text-blue-500"></i>
                                            </button>
                                          </div>
                                          <p className="mt-2 text-gray-500 text-sm">
                                            Enter your Email and instructions will be sent to you!
                                          </p>
                                          <form className="mt-4" onSubmit={(e) => { e.preventDefault(); handleForgotPassword(); }}>
                                <input
                                  type="email"
                                  placeholder="Enter your Email"
                                  value={resetEmail}
                                  onChange={(e) => setResetEmail(e.target.value)}
                                  className="w-full rounded-lg border py-3 p-2"
                                />
                                <button
                                  type="submit"
                                  disabled={resetLoading}
                                  className="mt-4 bg-[#FB9678] w-full p-3 rounded-lg text-white font-semibold hover:bg-[#e97a58]"
                                >
                                  {resetLoading ? "Sending..." : "RESET"}
                                </button>
                              </form>
                                        </>
                                      )}
                              
                                      {/* Signup */}
                                        {Signin === "Signup" && (
                                          <>
                                            <div>
                                             <img src={Logo} className="w-[276px]  m-auto -mt-4 " alt="" />
                                              <h1 className="text-center text-[24px] ">Signup</h1>
                                            </div>
                              
                                           <form
                                className="flex flex-col gap-7 mx-auto mt-5"
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    handleSubmitSignup();
                                  }
                                }}
                              >
                                {/* First Name */}
                                <div className="relative flex gap-10 w-full group">
                                  <input
                                    type="text"
                                    placeholder="First Name"
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    className="w-[50%] px-1 py-1 border-b border-gray-400 focus:outline-none focus:ring-0 bg-transparent"
                                  />
                              
                                  <input
                                    type="text"
                                    placeholder="Last Name"
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                    className="w-[50%] px-1 py-1 border-b border-gray-400 focus:outline-none focus:ring-0 bg-transparent"
                                  />
                                </div>
                              
                                {/* Username */}
                                <div className="relative flex gap-10 w-full group">
                                  <input
                                    type="text"
                                    placeholder="Username"
                                    value={username}
                                    onChange={(e) => {
                                      setusername(e.target.value);
                                      validateUsername(e.target.value);
                                    }}
                                    onBlur={() => validateUsername(username)}
                                    className={`w-[50%] px-1 py-1 border-b ${
                                      usernameError ? "border-red-500" : "border-gray-400"
                                    } focus:outline-none focus:ring-0 bg-transparent`}
                                  />
                              
                                   <input
                                    type="email"
                                    placeholder="Email"
                                    value={Email}
                                    onChange={(e) => {
                                      setEmail(e.target.value);
                                      validateEmail(e.target.value);
                                    }}
                                    onBlur={() => validateEmail(Email)}
                                    className={`w-[50%] px-1 py-1 border-b ${
                                      emailError ? "border-red-500" : "border-gray-400"
                                    } focus:outline-none focus:ring-0 bg-transparent`}
                                  />
                                </div>
                              
                                {/* Company Name */}
                                <div className="relative flex gap-10 w-full group">
                                  <input
                                    type="text"
                                    placeholder="Company Name"
                                    value={companyName}
                                    onChange={(e) => setCompanyName(e.target.value)}
                                    className="w-[50%] px-1 py-1 border-b border-gray-400 focus:outline-none focus:ring-0 bg-transparent"
                                  />
                               <div className="w-[50%]">
                                  <input
                                    type="text"
                                    placeholder="Mobile Number"
                                    value={Mobile}
                                    onChange={(e) => {
                                      setMobile(e.target.value);
                                      validateMobile(e.target.value);
                                    }}
                                    onBlur={() => validateMobile(Mobile)}
                                    className={`w-full px-1 py-1 border-b ${
                                      mobileError ? "border-red-500" : "border-gray-400"
                                    } focus:outline-none focus:ring-0 bg-transparent`}
                                  />
                              
                                  {/* ✅ Show error message */}
                                  {mobileError && (
                                    <p className="text-red-500 italic text-sm mt-1">
                                      *Please enter a valid mobile number (e.g., +971501234567).
                                    </p>
                                  )}
                                </div>
                                </div>
                              
                                {/* Address */}
                                <div className="relative w-full group">
                                  <input
                                    type="text"
                                    placeholder="Address"
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                    className="w-full px-1 py-1 border-b border-gray-400 focus:outline-none focus:ring-0 bg-transparent"
                                  />
                                </div>
                              
                               
                              
                               
                              
                                {/* Password */}
                                <div className="relative w-full group">
                                <input
                                  type={showPassword ? "text" : "password"}
                                  placeholder="Password"
                                  value={password}
                                  onChange={(e) => {
                                    setPassword(e.target.value);
                                    validatePassword(e.target.value);
                                  }}
                                  onBlur={() => validatePassword(password)}
                                  className={`w-full px-1 py-1 border-b ${
                                    passwordError ? "border-red-500" : "border-gray-400"
                                  } focus:outline-none focus:ring-0 bg-transparent pr-8`}  // Add pr-8 for icon space
                                />
                              
                                {/* Eye icon */}
                                <div
                                  className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500"
                                  onClick={() => setShowPassword(!showPassword)}
                                >
                                  {showPassword ? <i class="fa-solid fa-eye-slash"></i> : <i class="fa-solid fa-eye"></i>}
                                </div>
                              
                                {passwordError && (
                                  <p className="text-red-500 italic text-sm mt-1">
                                    *Password must be at least 6 characters and contain at least 1 letter and 1 number.
                                  </p>
                                )}
                              </div>
                              
                              
                              
                                {/* Confirm Password */}
                                <div className="relative w-full group">
                                <input
                                  type={showConfirmPassword ? "text" : "password"}
                                  placeholder="Confirm Password"
                                  value={confirmPassword}
                                  onChange={(e) => {
                                    setConfirmPassword(e.target.value);
                                    validateConfirmPassword(e.target.value);
                                  }}
                                  onBlur={() => validateConfirmPassword(confirmPassword)}
                                  className={`w-full px-1 py-1 border-b ${
                                    confirmPasswordError ? "border-red-500" : "border-gray-400"
                                  } focus:outline-none focus:ring-0 bg-transparent pr-8`}
                                />
                              
                                {/* Eye icon */}
                                <div
                                  className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500"
                                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                >
                                  {showConfirmPassword ? <i class="fa-solid fa-eye-slash"></i> : <i class="fa-solid fa-eye"></i>}
                                </div>
                              
                                {confirmPasswordError && (
                                  <p className="text-red-500 italic text-sm mt-1">
                                    *Passwords do not match.
                                  </p>
                                )}
                              </div>
                              
                              
                              
                                 <div className='flex items-center gap-4'>
                                              <label className='text-gray-400 ' htmlFor="image">Image:</label>
                                              <input
                                                className='px-2  rounded-xl'
                                                type="file"
                                                onChange={(e) => setImage(e.target.files[0])}
                                                id='image'
                                              />
                                            </div>
                              
                                {/* Signup Button */}
                                <button
                                  type="submit"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleSubmitSignup();
                                  }}
                                  className="w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600 disabled:cursor-not-allowed transition duration-200 disabled:bg-gray-300"
                                  disabled={
                                    usernameError ||
                                    emailError ||
                                    mobileError ||
                                    passwordError ||
                                    confirmPasswordError ||
                                    !username ||
                                    !Email ||
                                    !Mobile ||
                                    !password ||
                                    !confirmPassword
                                  }
                                >
                                  {loading ? (
                                    <span className="block w-[16px] h-[16px] border-2 border-b-0 border-white mt-[4px] mb-[4px] rounded-full m-auto animate-spin"></span>
                                  ) : (
                                    "Signup"
                                  )}
                                </button>
                              
                                {/* Already have account? */}
                                <div className="text-sm text-center">
                                  Already have an account?{" "}
                                  <Link onClick={() => setSignin("Signin")} className="text-[#2e5775] font-semibold">
                                    Login
                                  </Link>
                                </div>
                              </form>
                              
                                          </>
                                        )}
                                       
                                    </div>
                                  </div>
                              )}
                              
                              
             
            </div>
          
        </div>
        
                  </div>
                 
                </div>
        
               {/*3rd similar ships */}
                <div className="w-[25%] 2xl:w-[100%] 2xl:mt-5 h-full overflow-y-auto border bg-[#2e5775] border-gray-400 rounded  p-2">
          <h2 className="text-white text-lg font-semibold mb-2">Similar Ships</h2>
          {similarShips.length > 0 ? (
            similarShips.slice(0, 3).map((ship) => (
              <div key={ship.id} className="bg-white mb-3 p-2 rounded shadow">
                <p className="font-bold text-gray-800">{ship.short_description}</p>
                <p className="text-sm text-gray-600">Type: {ship.vessel_type}</p>
                <p className="text-sm text-gray-600">Flag: {ship.flag}</p>
                {/* Optionally show thumbnail */}
               <div>
          {(() => {
            let imageUrl = null;
        
            const images = ship.isFromReg
              ? allImagesReg.filter((img) => img.ships === ship.id)
              : allImages.filter((img) => img.ship === ship.id);
        
            imageUrl = images[0]?.image;
        
            if (!imageUrl) return null;
        
            const route = ship.isFromReg
              ? `/singleShipReg/${ship.id}`
              : `/singleShiphome/${ship.id}`;
        
            return (
              <img
               onClick={() => {
          navigate(route);
          window.location.reload(); // Refresh after navigation
        }}
                src={imageUrl}
                className="w-full h-[150px] cursor-pointer mt-1 rounded"
                alt="Ship"
              />
            );
          })()}
        </div>
        
              </div>
            ))
          ) : (
            <p className="text-gray-200">No similar ships found</p>
          )}
        </div>
              </div>
   
         <NewFooter />
       </div>
  );
}
